import summary from './actions/summary'
import placements from './actions/placements'
import keywords from './actions/keywords'
import adGroups from './actions/adGroups'
import accountSettings from './actions/accountSettings'
import session from './actions/session'
import actionLog from './actions/actionLog'
import common from './actions/common'
import campaigns from './actions/campaigns'

export default {
  ...summary,
  ...placements,
  ...keywords,
  ...adGroups,
  ...accountSettings,
  ...session,
  ...actionLog,
  ...common,
  ...campaigns
}
